import "shared/extensions/date";

import { Route, Routes } from "react-router-dom";

import { AccountSecurityHome } from "./Views/AccountSecurityHome/AccountSecurityHome";
import { PasswordManagement } from "./Views/PasswordManagement/PasswordManagement";
import { TwoFactorAuthentication } from "./Views/TwoFactorAuthentication/TwoFactorAuthentication";
import { SsoSettings } from "./Views/SsoSettings/SsoSettings";

export const AccountSecurity = () => {
  return (
    <Routes>
      <Route index element={<AccountSecurityHome />} />
      <Route path="password-management" element={<PasswordManagement />} />
      <Route path="sso" element={<SsoSettings />} />
      <Route path="two-factor-auth" element={<TwoFactorAuthentication />} />
    </Routes>
  );
};
